import React from "react";
import { useAutocomplete } from "../../../Pregrine/SearchBar";
import classes from "./autocomplete.module.css";
import Suggestions from "../suggestions/suggestions";

const Autocomplete = (props) => {
  const { setVisible, valid, visible, isSubmitted, searchText } = props;
  const talonProps = useAutocomplete({
    valid,
    visible,
    isSubmitted,
    searchText,
  });
  const {
    displayResult,
    messageType,
    products,
    filters,
    message,
  } = talonProps;

  const rootClassName = visible ? classes.root_visible : classes.root_hidden;

  return (
    <div className={rootClassName}>
      {message && <div className={classes.message}>{message}</div>}
      <div className={classes.suggestions}>
        {messageType !== "LOADING" && (
          <Suggestions
            displayResult={displayResult}
            products={products || {}}
            searchValue={searchText}
            setVisible={setVisible}
            visible={visible}
            filters={filters}
          />
        )}
      </div>
    </div>
  );
};

export default Autocomplete;
